import React from 'react'
import type { HeaderRowConfig } from '@ztechapps/webui.data-tools'
import { CheckboxHeaderCell } from '@ztechapps/webui.data-tools'
import { MenuHeaderCell } from '@ztechapps/webui.data-tools'
import { useProductSelectListContext } from './Context'

export const ListHeader = (props: HeaderRowConfig) => {
  const context = useProductSelectListContext()
  const { toggleSelectAll, hasSelectedAll } = context.listWithSelection

  return (
    <>
      <MenuHeaderCell />

      <CheckboxHeaderCell onChange={toggleSelectAll} checked={hasSelectedAll} />

      {props._renderDataHeaderCell()}
    </>
  )
}
